import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

interface AdBannerProps {
  slot?: string;
  format?: 'auto' | 'fluid' | 'rectangle' | 'vertical' | 'horizontal';
  responsive?: boolean;
  style?: React.CSSProperties;
}

const AdBanner: React.FC<AdBannerProps> = ({
  slot = '5962768395',
  format = 'auto',
  responsive = true,
  style = {}
}) => {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && adRef.current) {
        // Initialize adsbygoogle if not already initialized
        window.adsbygoogle = window.adsbygoogle || [];
        
        // Push the ad configuration
        window.adsbygoogle.push({});
      }
    } catch (err) {
      console.error('Error initializing AdSense:', err);
    }
  }, []);

  return (
    <div ref={adRef} style={{ textAlign: 'center', overflow: 'hidden', ...style }}>
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          textAlign: 'center',
          minWidth: '250px',
          minHeight: '200px',
          ...style
        }}
        data-ad-client="ca-pub-8166100374404073"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
        data-ad-layout-key="-6t+ed+2i-1n-4w"
      />
    </div>
  );
};

export default AdBanner; 